import { Pipe, PipeTransform } from '@angular/core';
import {GenDataCenterProvider} from '../../generated/serverModels/GenDataCenterProvider';

@Pipe({
  name: 'datacenterProvider',
})
export class DatacenterProviderPipe implements PipeTransform {

  transform(value: GenDataCenterProvider): string {
    switch (value) {
      case GenDataCenterProvider.CRYPTO_HOSTING:
        return 'Crypto hosting';
      case GenDataCenterProvider.RETAIL:
        return 'Retail';
      case GenDataCenterProvider.HOSTING:
        return 'Hosting';
      case GenDataCenterProvider.WHOLESALE:
        return 'Wholesale';
      case GenDataCenterProvider.HYPERSCALE:
        return 'Hyperscale';
      case GenDataCenterProvider.POWERED_SHELL:
        return 'Powered Shell';
      case GenDataCenterProvider.TELCO:
        return 'Telco';
      case GenDataCenterProvider.RETAIL_WHOLESALE:
        return 'Retail Wholesale';
      case GenDataCenterProvider.NEOCLOUD:
        return 'Neocloud';
      case GenDataCenterProvider.CRYPTO_MINING:
        return 'Crypto Mining';
      case GenDataCenterProvider.RESELLER:
        return 'Reseller';
      case GenDataCenterProvider.INVESTOR:
        return 'Investor';
      default:
        console.error(`${value.toString()} is not a valid GenDataCenterProvider`);
        return 'Not Available';
    }
  }

}
